import React from 'react';
import {
  Modal,
  Drawer,
  Form,
  Radio,
  Icon,
  Typography,
  Table,
  Button,
  Row,
  Col,
  Input,
  notification,
  Select,
} from 'antd';
import 'antd/dist/antd.css';

import reqwest from './apiRequest';
import dragula from 'dragula';
import 'dragula/dist/dragula.css';
import { parseInt } from 'lodash';

const { Title } = Typography;

class App extends React.Component {
  state = {
    data: [],
    key: false,
    loading: false,
    visible: false,
    isSendingRequest: false,
    deleteModalVisible: false,
    searchValue: '',
    detail: {},
  };

  constructor(props) {
    super(props);

    this.columns = [
      // {
      //   title: 'Sort',
      //   dataIndex: 'sort',
      //   key: 'display_index',
      //   width: 60,
      //   render: () => (
      //     <Icon
      //       type="menu"
      //       style={{
      //         fontSize: '13pt',
      //         fontWeight: 'bolder',
      //         cursor: 'pointer',
      //       }}
      //     />
      //   ),
      // },
      {
        title: 'Title (EN)',
        dataIndex: 'title_en',
        key: 'title_en',
        width: 100,
        align: 'center',
        render: (title_en) =>
          (
            <span style={{ fontSize: 15 }}>{title_en}</span>
          ),
      },
      {
        title: 'Title (MM)',
        dataIndex: 'title_bm',
        key: 'title_bm',
        width: 100,
        align: 'center',
        render: (title_bm) =>
          (
            <span style={{ fontSize: 15 }}>{title_bm}</span>
          ),
      },
      {
        title: 'Status',
        dataIndex: 'status',
        key: 'status',
        width: 100,
        align: 'center',
        render: (status) =>
          (
            <span style={{ fontSize: 15 }}>{status}</span>
          ),
      },
      {
        title: '',
        dataIndex: 'key',
        key: 'key',
        width: 70,
        render: (key) => (
          <Button
            onClick={() => {
              this.showDrawer(key);
            }}
            className="icon-btn"
          >
            <Icon type="edit" />
          </Button>
        ),
      },
    ];
  }

  componentDidMount() {
    document.title = 'IDA Setting';

    this.fetch();

    const container = document.querySelector('.ant-table-tbody');
    const drake = dragula([container], {
      moves: (el) => {
        this.start = this.getIndexInParent(el);
        return true;
      },
    });

    drake.on('drop', (el) => {
      this.end = this.getIndexInParent(el);
    });
  }

  fetch = (params = {}) => {
    this.props.pageLoading(true);
    this.setState({ loading: true });

    reqwest({
      url: process.env.REACT_APP_API_URL + '/ida_setting',
      method: 'get',
      type: 'json',
      data: {
        search: this.state.searchValue,
        ...params,
      },
    })
      .then((data) => {
        this.setState({
          data: data.results,
        });

        document.body.style.overflow = null;
      })
      .catch((err) => {})
      .always(() => {
        this.props.pageLoading(false);
        this.setState({ loading: false });
      });
  };

  saveRequest = (data = {}) => {
    return reqwest({
      url: process.env.REACT_APP_API_URL + '/ida_setting/save',
      method: 'post',
      type: 'json',
      data,
    })
      .then(() => {
        notification.success({
          key: 'notification',
          message: 'Success',
          description: `${data.id ? 'Update' : 'Create'} complete!`,
          duration: 3,
        });

        this.setState({ visible: false });

        this.fetch();
      })
      .catch((err) => {
        notification.error({
          key: 'notification',
          message: 'Fail',
          description: err.message,
          duration: 5,
        });
      })
      .always(() => {
        this.setState({ isSendingRequest: false });
      });
  };

  deleteRequest = (data = {}) => {
    return reqwest({
      url: process.env.REACT_APP_API_URL + '/ida_setting/delete',
      method: 'post',
      type: 'json',
      data,
    })
      .then(() => {
        notification.success({
          key: 'notification',
          message: 'Success',
          description: 'Delete complete!',
          duration: 3,
        });

        this.setState({ visible: false });

        this.fetch();
      })
      .catch((err) => {
        let message = err.message;

        if (err.responseText) {
          let jsonResponse = JSON.parse(err.responseText);
          message = jsonResponse.message;
        }

        notification.error({
          key: 'notification',
          message: 'Fail',
          description: message,
          duration: 5,
        });
      })
      .always(() => {
        this.setState({ isSendingRequest: false });
      });
  };

  getIndexInParent = (el) => {
    return Array.from(el.parentNode.children).indexOf(el);
  };

  showDrawer = async (key) => {
    const data = {
      key: undefined,
      section: '',
      title_en: '',
      title_bm: '',
      href: '',
      status: '',
    };

    if ((parseInt(key, 10) || 0) > 0) {
      Object.assign(
        data,
        this.state.data.find((item) => item.key === key) || {},
      );

      // Convert to string
      Object.assign(data, {
        section: data.section || '',
        title_en: data.title_en || '',
        title_bm: data.title_bm || '',
        href: data.href || '',
        status: data.status || '',
      });
    }

    this.props.form.setFieldsValue({
      id: data.key,
      section: data.section,
      title_en: data.title_en,
      title_bm: data.title_bm,
      href: data.href,
      status: data.status,
    });

    this.setState({
      detail: data,
      visible: true,
      isSendingRequest: false,
    });
  };

  onClose = () => {
    this.setState({
      visible: false,
    });
  };

  onSave = (e) => {
    e.preventDefault();

    this.setState({ isSendingRequest: true });

    this.props.form.validateFields((err, values) => {
      if (err) {
        notification.error({
          key: 'notification',
          message: 'Fail',
          description: 'Please fill complete form!',
          duration: 3,
        });

        this.setState({ isSendingRequest: false });

        return;
      }

      this.saveRequest(values);
    });
  };

  showDeleteConfirm = () => {
    Modal.confirm({
      title: 'Confirm',
      // icon: <ExclamationCircleOutlined />,
      content: 'Do you want to delete this item?',
      okText: 'Yes, Delete',
      cancelText: 'No',
      okType: 'danger',
      onOk: () => {
        const detail = this.state.detail;

        return this.deleteRequest({ id: detail.key });
      },
      onCancel: () => {
        Modal.destroyAll();
      },
    });
  };

  render() {
    const {
      isSendingRequest,
      detail,
    } = this.state;

    const { getFieldDecorator } = this.props.form;

    return (
      <div id="ida-setting-component">
        <Drawer
          id="ida-setting-component-drawer"
          title="IDA SETTING DETAIL"
          placement="right"
          closable={false}
          width={730}
          onClose={this.onClose}
          visible={this.state.visible}
          bodyStyle={{ paddingBottom: 80 }}
        >
          <Form onSubmit={this.onSave} layout={'vertical'}>
            <Form.Item label="" style={{ display: 'none' }}>
              {getFieldDecorator('id', {
                initialValue: '',
              })(<Input />)}
            </Form.Item>
            <Form.Item label="Section">
              {getFieldDecorator('section', {
                validateTrigger: ['onChange', 'onBlur'],
                initialValue: '',
                rules: [
                  { required: true, message: 'Please select section!' },
                ],
              })(
                <Select
                  style={{ width: '100%', marginRight: 8 }}
                >
                  <Select.Option value="">Please select</Select.Option>
                  <Select.Option value="btn_buy_dumex_dugro">Button buy dumex dugro</Select.Option>
                </Select>,
              )}
            </Form.Item>
            <Form.Item label="Title (EN)">
              {getFieldDecorator('title_en', {
                initialValue: detail.title_en,
              })(<Input placeholder="" />)}
            </Form.Item>
            <Form.Item label="Title (MM)">
              {getFieldDecorator('title_bm', {
                initialValue: detail.title_bm,
              })(<Input placeholder="" />)}
            </Form.Item>
            <Form.Item label="Link">
              {getFieldDecorator('href', {
                initialValue: detail.href,
              })(<Input placeholder="" />)}
            </Form.Item>

            <Form.Item label="Status">
              {getFieldDecorator('status', {
                validateTrigger: ['onChange', 'onBlur'],
                initialValue: 'active',
                rules: [
                  { required: true, message: 'Please input your status!' },
                ],
              })(
                <Radio.Group>
                  <Radio.Button value="active">
                    <i className="fa fa-check" style={{ marginRight: 5 }}></i>
                    Active
                  </Radio.Button>
                  <Radio.Button value="inactive">
                    <i className="fa fa-close" style={{ marginRight: 5 }}></i>
                    Inactive
                  </Radio.Button>
                </Radio.Group>,
              )}
            </Form.Item>

            <div
              style={{
                position: 'absolute',
                bottom: 0,
                width: '100%',
                borderTop: '1px solid #e8e8e8',
                padding: '10px 16px',
                left: 0,
                background: '#fff',
                borderRadius: '0 0 4px 4px',
                zIndex: 2,
              }}
            >
              <Row>
                <Col span={12}>
                  <Button
                    icon="close"
                    onClick={this.onClose}
                    style={{ backgroundColor: '#EDEDED' }}
                  >
                    Close
                  </Button>
                </Col>
                <Col span={12} className="text-right">
                  {detail.key && (
                    <Button
                      style={{
                        marginRight: 8,
                      }}
                      type="danger"
                      ghost
                      icon="delete"
                      onClick={this.showDeleteConfirm}
                      disabled={isSendingRequest}
                    >
                      Delete
                    </Button>
                  )}
                  <Button
                    htmlType="submit"
                    type="primary"
                    icon="save"
                    loading={isSendingRequest}
                    disabled={isSendingRequest}
                  >
                    {!detail.key ? 'Create' : 'Save'}
                  </Button>
                </Col>
              </Row>
            </div>
          </Form>
        </Drawer>

        <Row>
          <Col span={24}>
            <Title level={1}>IDA Setting</Title>
          </Col>
        </Row>

        <div className="paper-panel">
          <Row>
            <Col className="text-right">
              <Button
                type="primary"
                // style={{ minWidth: 140 }}
                onClick={() => this.showDrawer(-1)}
              >
                <Icon type="plus" />
                Create
              </Button>
            </Col>
          </Row>

          <Table
            columns={this.columns}
            dataSource={this.state.data}
            pagination={this.state.pagination}
            loading={this.state.loading}
            onChange={this.handleTableChange}
            rowKey={'key'}
          />
        </div>
      </div>
    );
  }
}

export default Form.create({ name: 'ida_setting_form' })(App);
